

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CREATEKRAKPI= createAsyncThunk(
  "createKraKpi/creafteKraKpi",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createKraKpiSlice = createSlice({
  name: "createKraKpiSlice",
  initialState: {
    createKraKpi: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateKraKpi: (state) => {
        state.createKraKpi.loading = false
        state.createKraKpi.error = false
        state.createKraKpi.data = []
        state.createKraKpi.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEKRAKPI.fulfilled, (state, action) => {
      state.createKraKpi = {
        ...state.createKraKpi,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEKRAKPI.pending, (state, action) => {
      state.createKraKpi = {
        ...state.createKraKpi,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEKRAKPI.rejected, (state, action) => {
      state.createKraKpi = {
        ...state.createKraKpi,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createKraKpiAction = {
    CREATEKRAKPI,
};

export { createKraKpiAction };
export default createKraKpiSlice.reducer;
export const {setInitialStateOfcreateKraKpi} = createKraKpiSlice.actions
